Vue.component("LoaderScreen", {
    props: ["visible"],
    template: `    
        <div id="LoaderScreen">
            <transition
                name="custom-classes-transition"
                :enter-active-class="enterAnimation"
                v-on:after-enter="onEnterComplete"
                :leave-active-class="leaveAnimation">
                    <div class="loader-screen__content" v-if="visible">
                        <div class="inner-wrapper">
                            <h1>LOADING {{getLoadProgress()}} </h1>
                            <div class="lds-dual-ring"></div>
                        </div>
                    </div>
            </transition>
        </div>
    `,
    data () {
        return {
            enterAnimation: "animated zoomIn",
            leaveAnimation: "animated zoomOut animation-delay-750",
            progress: 0
        }
    },

    mounted () {
        window.app.radio.$on("LOADER_PROGRESS", (progress) => {
            this.progress = progress;
        })
    },
    methods: {
        onEnterComplete () {},
        getLoadProgress() {
            return this.progress == 0 ? "..." : (Math.round(this.progress) + " %");
        }
    }

})